import styled from "styled-components";

export const FormCurrencyInputWrapper = styled.div`
  height: 48px;
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  transition: all 300ms ease;
  font-size: 16px;
  padding: 0 0 0 16px;
  color: #00000080;
  font-family: var(--font-family-primary);
`;
